import QRScanner from '../../components/productScanner/scanner';

const ScannerPage = () => {
  return (
    <div><QRScanner /></div>
  )
}

export default ScannerPage;